import { GridColumns } from 'shared/types';
import { AccountNumberParams } from 'pages/managePricing/managePricingResolver';
import { useParams } from 'react-router-dom';
import { ProductFilterEnum } from 'shared/constants';
import { createTableDataContext } from 'shared/providers/provideTableData';
import { TAddProductsData } from 'types/backend';
import { ProductsResolver } from './ProductsResolver';

interface CatalogProductsResolverProps {
    columnConfig: GridColumns<TAddProductsData>;
}

export const catalogProductsContext = createTableDataContext<TAddProductsData>();

export function CatalogProductsResolver({columnConfig}: CatalogProductsResolverProps) {
    const {accountNumber} = useParams<AccountNumberParams>();

    return (
        <ProductsResolver
            columnConfig={columnConfig}
            productsContext={catalogProductsContext}
            name='CatalogProduct'
            productTabSelected={ProductFilterEnum.CATALOG}
            alternateQueryPath={`subset/${accountNumber}`}
            title='Available Catalog Products'
        />
    );
}
